import { Injectable } from '@angular/core'

declare const gtag: (...args: any[]) => void

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService 
{
  trackEvent(name: string, params: Record<string, any> = {}) 
  {
    if (typeof gtag === 'function') {
      gtag('event', name, params);
    }
  }
}
